'use strict'
Object.defineProperty(exports, '__esModule', { value: true })
exports.objectFromQueryString = void 0
exports.objectFromQueryString = function (qs) {
  if (!qs) return null
  if (qs[0] === '?') {
    qs = qs.slice(1)
  }
  return JSON.parse(
    '{"' + qs.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
    function (key, value) {
      return key === '' ? value : decodeURIComponent(value)
    }
  )
}
//# sourceMappingURL=objectFromQueryString.js.map
